module.exports = __webpack_public_path__ + "static/media/want-to-sell-your-item-we-buy-your-vintage-design-furniture.b7fe5754.jpg";